import React from 'react';

import { KB_LIVE_COPY } from '../../constants/training';
import TrainingStatusLine from '../training/TrainingStatusLine';

/**
 * Gentle nudge while the server is checking in on a silent rep, as one status
 * line of the panel. Nothing to click: the rep only has to start talking, and
 * the server moves on by itself if they do not.
 */
export const KbSilenceBanner: React.FC = () => (
  <TrainingStatusLine dotClassName="bg-warning animate-pulse">
    <span className="font-semibold text-ink">{KB_LIVE_COPY.stillThereTitle}</span> {KB_LIVE_COPY.stillThereBody}
  </TrainingStatusLine>
);

export default KbSilenceBanner;
